// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTerritories} from '../../../user/shared/repositories/territories';

export const readTerritories = racfId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const territories = await getTerritories(racfId);

            dispatch({
                territories,
                type: actions.READ_SPECIAL_ALLOWANCE_CLAIM_STATUS_TERRITORIES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/action-creators/read-territories.js